export interface IAGenerationResponse {
  Id?: string;
  ProviderName?: string;
  Headline?: string;
  BodyCopy?: string;
  Status?: string;
  Error?: string;
  FeedbackAction?: IACopyFeedbackAction;
  CorrectedHeadline?: string;
  CorrectedBodyCopy?: string;
  FeedbackNotes?: string;
  FeedbackCategory?: string;
}

export interface IAGenerationOutcome {
  Request?: { Id?: string; Status?: string; Notes?: string };
  Responses?: IAGenerationResponse[];
}

export type IACopyErrorType =
  | 'generate_failed'
  | 'empty'
  | 'all_failed'
  | 'poll_failed'
  | 'feedback_failed'
  | 'complete_generation_failed'
  | 'regenerate_failed';

export interface IACopyError {
  type: IACopyErrorType;
  message: string;
}

export type IACopyFeedbackAction = 'Accepted' | 'Rejected' | 'Edited';

export type IACopyFeedbackCategory =
  | 'GuidelineViolation'
  | 'ToneWrong'
  | 'FactualError'
  | 'GrammarPunctuation'
  | 'MissingContent'
  | 'Formatting'
  | 'Other';

export const IACOPY_FEEDBACK_CATEGORIES: { value: IACopyFeedbackCategory; label: string }[] = [
  { value: 'GuidelineViolation', label: 'Guideline violation' },
  { value: 'ToneWrong', label: 'Tone wrong' },
  { value: 'FactualError', label: 'Factual error' },
  { value: 'GrammarPunctuation', label: 'Grammar / punctuation' },
  { value: 'MissingContent', label: 'Missing content' },
  { value: 'Formatting', label: 'Formatting' },
  { value: 'Other', label: 'Other' },
];

export interface IACopyFeedbackRequest {
  Action: IACopyFeedbackAction;
  OriginalHeadline: string;
  OriginalBodyCopy: string;
  Disclaimer: string;
  CorrectedHeadline?: string;
  CorrectedBodyCopy?: string;
  RejectionNotes?: string;
  CorrectionNotes?: string;
  Category?: string;
}
